// import { arrayToObjectCovert } from '../../../services/commonService';

export const handleFetchInvoicesFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.invoices = action.payload.data;
    state.invoicesOrder = action.payload.data.map(invoice => invoice.id);
    state.currentPage = action.payload.current_page;
    state.perPage = action.payload.per_page;
    state.totalPages = action.payload.total_pages;
    state.total = action.payload.total_count;
    state.lastUpdated = action.payload.last_updated;
};

export const handleFetchInvoiceFixedIteamListFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.invoicesFixedItemList = action.payload;
};

export const handleFetchInvoiceGetBasePriceFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.invoicesBasePrice = action.payload;
}

export const handleFetchPromotionListFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.promotionList = action.payload;
}

export const handleCalculatePriceFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.calculatePrice = action.payload;
}

export const handleAddContractInvoiceFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.currentInvoices = action.payload;
    state.error = null;
}

export const handleFetchInvoiceStatusFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.invoiceStatus = action.payload.data;
}

export const handleFetchInvoiceDetailsFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.invoiceDetails = action.payload.data;
}

export const handleFetchContractGlobalStatusListFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.contractGLobalList = action.payload.data;
};

export const handleFetchInvoiceActivityLogListFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.invoiceActivityLogList = action.payload.data;
}

export const handleUpdatePaymentInvoiceFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.currentInvoices = action.payload;
    state.error = null;
}

export const handleFetchReservationFeeFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.reservationFee = action.payload.data;
}

export const handleUploadInvoicePaymentAttachmentFulfilled = (state) => {
    state.status = 'succeeded';
    state.error = null;
}